import { ISensorAdditionalField } from '../sensoradditionalfield.model';
export class SensorAdditionalField implements ISensorAdditionalField {
  sensorAdditionalFieldID?: number;
  sensorID!: number;
  category!: string;
  value!: string;

  constructor(sensorID: number, category: string, value: string, sensorAdditionalFieldID?: number) {
    this.sensorAdditionalFieldID = sensorAdditionalFieldID;
    this.sensorID = sensorID;
    this.category = category;
    this.value = value;
  }
}
